import { Icon, IconName } from '@ardoq/icons';
import { connect } from '@ardoq/rxbeach';
import {
  PanelContainer,
  PanelHeader,
  SectionsContainer,
} from 'appLayout/ardoqStudio/saveAsViewpoint/atoms';
import { surveyPane$ } from './surveyPane$';
import { SurveyPaneState } from './types';
import { contextToolBarCommands } from 'canvas/contextToolBar/contextToolBarCommands';
import { ArdoqLoaderComponent, LoaderColor, LoaderSize } from '@ardoq/loader';
import { Footer } from '../Footer';
import { Box } from '@ardoq/layout';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { t, Trans } from '@ardoq/i18n';

const SurveyPaneBase = ({ component, survey }: SurveyPaneState) => {
  // i18nLocale$.state OK here: SurveyPane is a standalone panel not connected to i18nLocale$ stream
  const i18nLocale = i18nLocale$.state;
  if (!survey || !component) {
    return (
      <PanelContainer>
        <PanelHeader>
          <Icon iconName={IconName.SURVEYS} />
          <span>{t(i18nLocale, 'canvas:surveyPaneTitle', 'Survey')}</span>
        </PanelHeader>
        <Box padding="xlarge" height="full">
          <ArdoqLoaderComponent
            size={LoaderSize.SMALL}
            loaderColor={LoaderColor.BRAND}
            loaderText={t(
              i18nLocale,
              'canvas:loadingSurveyText',
              'Loading survey...'
            )}
            ariaLabel={t(i18nLocale, 'loader:ariaLabel', 'loader')}
          />
        </Box>
        <Footer onCancel={contextToolBarCommands.hidePane} />
      </PanelContainer>
    );
  }
  return (
    <PanelContainer>
      <PanelHeader>
        <Icon iconName={IconName.SURVEYS} />
        <span>{survey.name}</span>
      </PanelHeader>
      <SectionsContainer>
        <Trans
          i18nKey="canvas:surveyPanePlaceholder"
          defaults="Survey will go here. Selected component is {{componentName}}"
          values={{ componentName: component.name }}
        />
      </SectionsContainer>
      <Footer onCancel={contextToolBarCommands.hidePane} />
    </PanelContainer>
  );
};

export const SurveyPane = connect(SurveyPaneBase, surveyPane$);
